import React, { useEffect } from "react";
import Header from "../components/Header";

const STATUS_META_NAME = "prerender-status-code";

export default function NotFoundPage({ navigate, user, onLogin, onAccount, showBlog = true, onShareSite }) {
  useEffect(() => {
    document.title = "СоцПлан | Страница не найдена";
  }, []);

  useEffect(() => {
    const head = document.head;
    if (!head) {
      return undefined;
    }
    let meta = head.querySelector(`meta[name="${STATUS_META_NAME}"]`);
    let previousContent;
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", STATUS_META_NAME);
      head.appendChild(meta);
    } else {
      previousContent = meta.getAttribute("content");
    }
    meta.setAttribute("content", "404");
    return () => {
      if (!meta) return;
      if (previousContent) {
        meta.setAttribute("content", previousContent);
      } else {
        head.removeChild(meta);
      }
    };
  }, []);
  return (
    <div className="min-h-screen bg-slate-50">
      <Header
        navigate={navigate}
        user={user}
        onLogin={onLogin}
        onAccount={onAccount}
        showBlog={showBlog}
        onShareSite={onShareSite}
      />
      <div className="mx-auto max-w-3xl px-4 py-16 text-center">
        <h1 className="text-2xl font-semibold text-slate-900 mb-2">Страница не найдена</h1>
        <p className="text-slate-600 mb-6">Проверьте правильность адреса или вернитесь на главную.</p>
        <button
          onClick={() => navigate('home')}
          className="inline-flex h-11 items-center justify-center rounded-lg bg-blue-600 px-5 text-white text-[15px] font-semibold hover:bg-blue-700"
        >
          На главную
        </button>
      </div>
    </div>
  );
}
